/* eslint-disable no-useless-escape */
// react
import PropTypes from 'prop-types'
import React from 'react'

// css
import './styles.scss'

// dependencies
import API from '@st-operations/uikit/API.js'
import {
  Button,
  BUTTON_THEME,
  BUTTON_SIZE,
  CheckBox,
  Input,
  BarLoader,
} from '@st-operations/uikit/src/v2/index.js'

// libraries
import User from '../../lib/User'
import NavigationContext from '../../contexts/NavigationContext.jsx'

// api
const platform_api = new API('https://platform-api.sharethis.com')

// page
class AcceptInvitationPageComponent extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      button_text: 'GET STARTED',
      error_msg: '',
      has_accepted_terms: false,
      loading: false,
      password: '',
    }

    this.createAccount = this.createAccount.bind(this)
    this.onPasswordChange = this.onPasswordChange.bind(this)
    this.onTermsChange = this.onTermsChange.bind(this)
  }

  componentDidMount() {
    // hide navigation
    this.props.setShowSidebar(false)
    this.props.setShowContentContainer(false)

    const { search } = this.props.location
    let domain, email, property_id, team_id, token, roles
    const search_domain = /[\?\&]domain=([0-9a-zA-Z_\.\-\%]+)/.exec(search)
    const search_email = /[\?\&]email=([0-9a-zA-Z_\.\-\%]+)/.exec(search)
    const search_property_id = /[\?\&]property_id=([0-9a-zA-Z_\.\-]+)/.exec(search)
    const search_team_id = /[\?\&]team_id=([0-9a-zA-Z_\.]+)/.exec(search)
    const search_token = /[\?\&]invitation_token=([0-9a-zA-Z_\.\-]+)/.exec(search)
    const search_roles = /[\?\&]roles=([0-9a-zA-Z_\:\,\%]+)/.exec(search)

    if (search_domain) {
      domain = search_domain[1]
      localStorage.setItem('domain', domain)
      this.setState({ domain })
    }
    if (search_email) {
      email = search_email[1]
      email = decodeURIComponent(email)
      localStorage.setItem('email', email)
    }
    if (search_property_id) {
      property_id = search_property_id[1]
      localStorage.setItem('property_id', property_id)
    }
    if (search_team_id) {
      team_id = search_team_id[1]
      localStorage.setItem('team_id', team_id)
    }
    if (search_token) {
      token = search_token[1]
      localStorage.setItem('invitation-token', token)
    }
    if (search_roles) {
      roles = search_roles[1]
      roles = decodeURIComponent(roles)
      roles = roles.split(',')
      let roles_obj = {}
      for (let i = 0; i < roles.length; i++) {
        let parts = roles[i].split(':')
        roles_obj[parts[0]] = parts[1]
      }
      localStorage.setItem('roles', JSON.stringify(roles_obj))
    }
  }

  componentWillUnmount() {
    this.props.setShowSidebar(true)
    this.props.setShowContentContainer(true)
  }

  createAccount() {
    const { has_accepted_terms, password } = this.state
    const button_text = 'GET STARTED'
    const email = localStorage.getItem('email')
    const team_id = localStorage.getItem('team_id')
    const token = localStorage.getItem('invitation-token')

    if (!has_accepted_terms) {
      this.setState({ error_msg: 'Please agree to the Terms of Use' })
    } else {
      this.setState({
        button_text: 'just a moment...',
        loading: true,
      })
      toast('creating account...', { autoClose: '3000', position: 'top-right' })

      // sign up
      User.register({ email, password, team_id, token }, (err, resp) => {
        if (err) {
          this.setState({
            loading: false,
            button_text,
            error_msg: err.error || err.message,
          })
        } else {
          let callback = (err, resp) => {
            if (err) {
              this.setState({
                button_text,
                error_msg: err.error || err.message,
                laoding: false,
              })
              return
            }
            User.refresh(() => {
              // user data received, transition to dashboard
              this.props.history.push('/')
            })
          }

          setTimeout(() => {
            User.acceptInvitation(token, team_id, callback)
          }, 2000)
        }
      })
    }
  }

  onPasswordChange(value) {
    this.setState({ password: value })
  }

  onTermsChange() {
    let { has_accepted_terms } = this.state
    this.setState({ has_accepted_terms: !has_accepted_terms })
  }

  render() {
    const { button_text, error_msg, loading, has_accepted_terms } = this.state
    const { password } = this.state
    const { logo } = this.props
    let domain = localStorage.getItem('domain') || ''
    const email = localStorage.getItem('email') || ''

    return (
      <div id="st-accept-invitation-page">
        <div className="st-content">
          <div className="st-logo">
            <img src={logo} />
          </div>

          <div className="title">{`Choose a password below to create your
          account and get started.`}</div>

          <BarLoader containerStyle={{ opacity: loading ? 1 : 0, width: 300, margin: '0 auto' }} />

          <If condition={error_msg}>
            <div className="error">{error_msg}</div>
          </If>

          <If condition={domain}>
            <Input
              autoComplete="randomstring"
              id="accept-invitation-omain"
              label="Domain"
              name="domain"
              onChange={this.onDomainChange}
              type="text"
              value={domain}
            />
          </If>

          <Input disabled={true} label="Email" onChange={this.onEmailChange} placeholder={email} />

          <Input
            id="accept-invitation-password"
            autocomplete="off"
            onChange={this.onPasswordChange}
            value={password}
            type="password"
            label="Password"
          />

          <CheckBox
            id="terms-checked"
            checked={has_accepted_terms}
            onChange={this.onTermsChange}
            containerStyle={{ color: '#444', margin: '0 auto' }}
            label={
              <>
                {'I have read and agree to the '}
                <a href="https://www.sharethis.com/publisher-terms-of-use/" target="_blank">
                  Terms of Use
                </a>
                {' and '}
                <a href="https://www.sharethis.com/privacy" target="blank">
                  Privacy Notice
                </a>
                .
              </>
            }
          />

          <Button
            size={BUTTON_SIZE.LARGE}
            theme={BUTTON_THEME.SECONDARY}
            onClick={() => this.createAccount()}
          >
            {button_text}
          </Button>
        </div>
      </div>
    )
  }
}

AcceptInvitationPageComponent.propTypes = {
  logo: PropTypes.object,
  name: PropTypes.oneOf(['data-studio', 'name']),
  setShowSidebar: PropTypes.func,
  setShowContentContainer: PropTypes.func,
}

AcceptInvitationPageComponent.defaultProps = {
  logo: {},
  name: 'data-studio',
  setShowSidebar: () => {},
  setShowContentContainer: () => {},
}

const AcceptInvitationPage = (props) => (
  <NavigationContext.Consumer>
    {({ setShowSidebar, setShowContentContainer }) => (
      <AcceptInvitationPageComponent
        {...props}
        setShowSidebar={setShowSidebar}
        setShowContentContainer={setShowContentContainer}
      />
    )}
  </NavigationContext.Consumer>
)

// export
export default AcceptInvitationPage
